var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef } from 'react';
import { useSwipeable as useSwipeableInternal, } from 'react-swipeable';
export const DATA_SWIPE_DIRECTIONS_ATTRIBUTE = 'data-swipe-directions';
/**
 * Хук для работы с событиями свайпа
 */
export function useSwipeable(_a) {
    var { availableDirections, enabled = true } = _a, options = __rest(_a, ["availableDirections", "enabled"]);
    const canSwipe = useRef(true);
    const onSwipeStart = eventData => {
        var _a;
        if (availableDirections) {
            if (!availableDirections.includes(eventData.dir)) {
                canSwipe.current = false;
                return;
            }
            if (!options.onSwipeStart) {
                return;
            }
            eventData.event.stopPropagation();
        }
        (_a = options.onSwipeStart) === null || _a === void 0 ? void 0 : _a.call(options, eventData);
    };
    const onSwiping = eventData => {
        var _a;
        if (availableDirections) {
            if (!canSwipe.current) {
                return;
            }
            eventData.event.stopPropagation();
        }
        (_a = options.onSwiping) === null || _a === void 0 ? void 0 : _a.call(options, eventData);
    };
    const onSwiped = eventData => {
        var _a;
        if (availableDirections) {
            if (!canSwipe.current) {
                canSwipe.current = true;
                return;
            }
            eventData.event.stopPropagation();
        }
        (_a = options.onSwiped) === null || _a === void 0 ? void 0 : _a.call(options, eventData);
    };
    const handlers = useSwipeableInternal(enabled ? Object.assign(Object.assign({}, options), { onSwipeStart, onSwiping, onSwiped }) : {});
    return Object.assign(Object.assign({}, handlers), { [DATA_SWIPE_DIRECTIONS_ATTRIBUTE]: enabled && availableDirections ? availableDirections.join(' ') : undefined });
}
